import * as React from 'react';
import * as $ from 'jquery';
import Loader from '../shared/loader';
import ProgressiveImage from 'react-progressive-image';

// const ProgressiveImage: any = ReactProgressiveImage;
export default class extends React.Component<any, any> {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    $(document).ready(function() {
      $('.parallax').parallax();
    });
  }

  render() {
    return [
      <div className="parallax-container hide-on-small-only">
        <div className="parallax">
          <ProgressiveImage src="/images/wallet.jpg" placeholder="/images/wallet-min.jpg">
            {src => <img onLoad={() => this.setState({ loaded: true })} src={src} alt="wallet" />}
          </ProgressiveImage>
        </div>
        {this.state.loaded && (
          <div className="white-text text-lighten-4 logo-header">
            <h4>Manage your expenses</h4>
          </div>
        )}
        {!this.state.loaded && <Loader />}
      </div>,
      <div className="row hide-on-med-and-up">
        <div className="center">
          <h4>Manage your expenses</h4>
        </div>
      </div>,
      <div className="container">
        <div id="easy" className="col s12">
          <div className="row">
            <h3 className="landing-header center underline">Easy to use</h3>
            <div className="indicator" />
            <br /> <br />
          </div>

          <div className="row">
            <div className="col s6">
              <img className="responsive-img" src="/images/add.png" />
            </div>
            <div className="col s6">
              <h5>Easily add and categorize expenses</h5>
            </div>
          </div>

          <div className="row">
            <br /> <br />
          </div>

          <div className="row">
            <div className="col s5 valign-wrapper">
              <h5>Crosscheck you account balance</h5>
            </div>

            <div className="col s7">
              <img className="responsive-img" src="/images/accounts.png" />
            </div>
          </div>
        </div>

        <div id="encrypted" className="col s12">
          <div className="row">
            <br /> <br />
          </div>
          <div className="row">
            <h3 className="landing-header center underline">Encrypted</h3>
            <div className="indicator" />
            <br /> <br />
          </div>

          <div className="row">
            <div className="col s7">
              <img className="responsive-img" src="/images/unencrypted.png" />
            </div>

            <div className="col s5">
              <h5>This is what you enter and see.</h5>
            </div>
          </div>

          <div className="row">
            <br /> <br />
          </div>

          <div className="row">
            <div className="col s12">
              <h5>This is how we save it. The values you enter never reach our servers.</h5>
            </div>
          </div>

          <div className="row">
            <div className="col s12">
              <img className="responsive-img" src="/images/encrypted.jpg" />
            </div>
            <br />
          </div>
        </div>

        <div id="test-swipe-3" className="col s12 " />
      </div>
    ];
  }
}



// WEBPACK FOOTER //
// ./src/pages/landing-page.tsx